import { Component, OnInit } from '@angular/core';

import { AdminService } from './admin.service'

import { Router, ActivatedRoute} from '@angular/router';



import { DataTableModule,SharedModule, ContextMenu} from 'primeng/primeng';

import { DataTable } from 'primeng/primeng';
import { Column } from 'primeng/primeng';
import { Header } from 'primeng/primeng';
import { Button } from 'primeng/primeng';
import { MenuItem } from 'primeng/primeng';
import { Menu } from 'primeng/primeng';
import { ContextMenuModule } from 'primeng/primeng';
import { ContextMenuSub } from 'primeng/primeng';

@Component({
    providers: [AdminService],
    //templateUrl: 'app/administration/admin.component.html',
    template: require('./admin.component.html'),
    directives: [DataTable, Column, Header, Button, Menu, ContextMenu, ContextMenuSub]
})
 
export class AdminComponent implements OnInit {
    retrievingUsers = false;
    users: any[]; 
    alerts: any[];  
    items: MenuItem[];
    selectedUser: any;

    constructor(private router: Router,
        private adminService: AdminService, 
        private route: ActivatedRoute) {}    

    ngOnInit() : void{
        this.users = [];
        
        this.getUsers();
        this.items = [
            {label: 'Edit', icon: 'fa-edit', command: (event) => this.editUser(this.selectedUser)},
            {label: 'Delete', icon: 'fa-trash', command: (event) => this.deleteUser(this.selectedUser)}
        ];

        
    }

	getUsers(){
	    this.retrievingUsers = true;

        this.adminService.getUsers()
            .subscribe(
                users => {
                    this.users = users;
                    this.users.map(user => {
                        user.roles = user.roles.map((role: any) => role.name).join(', ');
                    })
                },
                error => {
				    this.alerts = [];
				    this.alerts.push({type: 'danger', msg: 'There was an error retrieving users.'});},
                () => this.retrievingUsers = false);
    }

    addUser(){			
        this.router.navigate(['/user-admin']);
	}
		
    editUser(user: any){
        this.router.navigate(['/user-admin', { id: user.id}]);
    }

    deleteUser(user: any){
        let confirmAnswer = confirm("Are you sure you want to delete user " + user.userName);

        if(confirmAnswer == true){
		this.adminService.deleteUser(user.id)
            .subscribe(
                users => {
                    this.retrievingUsers = true;
                    this.alerts = [];
				    this.alerts.push({type: 'success', msg: 'Successfully removed user'});
				    this.getUsers();},
                error => {
				    this.alerts = [];
				    this.alerts.push({type: 'danger', msg: 'Failed to remove user'});
                },
                () => this.retrievingUsers = false);
        }       
	}
}



/** WEBPACK FOOTER **
 ** ./app/administration/admin.component.ts
 **/